
  document.addEventListener('alpine:init', () => {
    Alpine.store('selectedRow', {
      id: null, // Tracks the currently selected row's ID
    });
  });

